import { createContext, useContext } from "react";

import type { TSubjectDetail } from "@/lib/types";

type SubjectContextValue = {
  subject: TSubjectDetail;
};

const SubjectContext = createContext<SubjectContextValue>(
  {} as SubjectContextValue,
);

export function SubjectProvider({
  children,
  subject,
}: {
  children: React.ReactNode;
  subject: TSubjectDetail;
}) {
  return (
    <SubjectContext.Provider value={{ subject }}>
      {children}
    </SubjectContext.Provider>
  );
}

export function useSubject() {
  const ctx = useContext(SubjectContext);
  if (!ctx) {
    throw new Error("useSubject must be used within a SubjectProvider");
  }
  return ctx;
}
